import { Injector } from '@angular/core';

/**
 * Provides global access to the injector. 
 * Requires help from the application to work.
 */
export class GlobalInjector {

    private static _injector : Injector = null;
    private static _ready : Promise<void> = null;
    private static _markReady : () => void = () => {};

    static get injector() : Injector {
        if (!this._injector)
            throw new Error(`The global injector is not ready yet.`);
        return this._injector;
    }

    static set injector(value : Injector) {
        this._injector = value;
        this._markReady();
    }

    static get ready() : Promise<void> {
        if (this._injector)
            return Promise.resolve();
        
        if (!this._ready)
            this._ready = new Promise<void>((resolve, reject) => this._markReady = resolve);
        
        return this._ready;
    }
}